<div class="invoices-bar-chart">
  <ng-container *ngIf="report$ | async as report">
    <div
      *ngIf="report.errorMessage; else chart"
      class="request-error"
      i18n="@@segments-bar-chart.accountInvoicesRequestError"
    >
      Something went wrong
    </div>
    <ng-template #chart>
      <div class="bar-chart-container">
        <ng-container *ngIf="chartData$ | async">
          <ng-container *ngIf="_hasData; else noData">
            <div class="bar-chart-heading">
              <span class="h3" i18n="@@segments-bar-chart.accountInvoicesChartTipUnit">Segments</span>
            </div>
            <canvas #chart id="invoices-bar-chart-ctx"></canvas>
          </ng-container>
        </ng-container>
      </div>
    </ng-template>
    <ng-template #noData>
      <div *ngIf="!report.updateRequired" class="no-chart-data">
        <svg class="kaliuk kaliuk-big">
          <use href="'/assets/images/svg_ico/icons.svg#kaliuk'"></use>
        </svg>
        <span i18n="@@segments-bar-chart.accountInvoicesNoDataForPeriod"
          >There is no data available for this selection</span
        >
      </div>
    </ng-template>
  </ng-container>
</div>
